import { Guid } from "@/types"

export interface IGetDivisionDto {
    id: string
    name: string
}

export class Division {
    id: Guid
    name: string

    constructor(dto: IGetDivisionDto) {
        this.id = dto.id
        this.name = dto.name
    }
}
